/* JUST START Visual Engine — deferred media activation.
 *
 * Owns every poster-first video that is not driven by jst-visual-lab.js
 * (product galleries, mainly). Three rules, enforced here rather than per
 * section, so a page with ten clips behaves like a page with one:
 *
 *   1. Nothing is fetched until the customer asks for it.
 *   2. Exactly one video plays at a time, document-wide.
 *   3. A video that leaves the viewport, or a tab that goes to the background,
 *      stops — it does not keep decoding frames nobody is watching.
 *
 * One delegated listener and one shared IntersectionObserver cover the whole
 * document, so the cost does not grow with the number of media items.
 */
(() => {
  'use strict';

  let exitObserver = null;
  let playing = null;

  const observeExit = (video) => {
    if (!('IntersectionObserver' in window)) return;
    if (!exitObserver) {
      exitObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) return;
          const video = entry.target;
          if (!video.paused) video.pause();
          if (playing === video) playing = null;
        });
      }, { threshold: 0.01 });
    }
    exitObserver.observe(video);
  };

  const pauseOthers = (except) => {
    document.querySelectorAll('.jst-deferred-media video').forEach((video) => {
      if (video !== except && !video.paused) video.pause();
    });
  };

  function activate(root) {
    if (!root || root.dataset.mediaLoaded === 'true') return;
    const template = root.querySelector('[data-jst-media-template]');
    if (!template) return;

    root.dataset.mediaLoaded = 'true';
    root.replaceChildren(template.content.cloneNode(true));

    const playable = root.querySelector('video, iframe');
    if (!playable || playable.tagName !== 'VIDEO') return;

    /* An iframe is left alone: a third-party player owns its own lifecycle and
       we deliberately do not reach into it. */
    pauseOthers(playable);
    playing = playable;
    observeExit(playable);
    playable.addEventListener('play', () => {
      pauseOthers(playable);
      playing = playable;
    });

    const promise = playable.play();
    if (promise && promise.catch) promise.catch(() => {});
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-jst-media-load]');
    if (trigger) activate(trigger.closest('[data-jst-deferred-media]'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const trigger = event.target.closest('[data-jst-media-load]');
    if (!trigger) return;
    event.preventDefault();
    activate(trigger.closest('[data-jst-deferred-media]'));
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden && playing && !playing.paused) playing.pause();
  });

  window.addEventListener('pagehide', () => {
    if (playing && !playing.paused) playing.pause();
  });
})();
